import IPassengerPhonNumberViewModel from '@/components/Passenger/models/IPassengerPhoneNumberViewModel';
import { IEntityMapping, IPropertyMapping } from '@/typings/import';

export default class PhoneNumberMapping
  implements IEntityMapping<IPassengerPhonNumberViewModel> {

  static readonly NON_ENTITY_MAPPINGS = [ 'passengerName', 'passengerExternalId', 'passengerSsn', 'creationColumn' ];
  static readonly ENTITY_CREATION_MAPPING = 'creationColumn';

  passengerName: IPropertyMapping = {
    propertyName: 'passengerName',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  passengerExternalId: IPropertyMapping = {
    propertyName: 'passengerExternalId',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  passengerSsn: IPropertyMapping = {
    propertyName: 'passengerSsn',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  creationColumn: IPropertyMapping = {
    propertyName: 'creationColumn',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  number: IPropertyMapping = {
    propertyName: 'number',
    propertyType: 'string',
    required: true,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  sms: IPropertyMapping = {
    propertyName: 'sms',
    propertyType: 'boolean',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  showToDriver: IPropertyMapping = {
    propertyName: 'showToDriver',
    propertyType: 'boolean',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  assistant: IPropertyMapping = {
    propertyName: 'assistant',
    propertyType: 'boolean',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };

  constructor(mapping?: IEntityMapping<IPassengerPhonNumberViewModel>) {
    if (mapping) {
      Object.keys(mapping).forEach(k => this[k] = mapping[k]);
    }
  }

  get props(): IPropertyMapping[] {
    return Object.keys(this).map(k => this[k]);
  }

  isValid(): boolean {
    return true;
  }

  updateSearchProperty(searchProperty: IPropertyMapping) {
    let updatedProperty: IPropertyMapping | null = null;
    switch (searchProperty.propertyName) {
      case 'name':
        updatedProperty = this.passengerName;
        break;
      case 'externalId':
        updatedProperty = this.passengerExternalId;
        break;
      case 'ssn':
        updatedProperty = this.passengerSsn;
        break;
    }
    if (!updatedProperty) {
      return;
    }

    updatedProperty.cell = searchProperty.cell;
    updatedProperty.static = searchProperty.static;
    updatedProperty.useStatic = searchProperty.useStatic;
  }
}
